import { useState } from "react";
import { Star } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { useStore } from "../context/StoreContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inputCls = "w-full rounded-xl border border-stone-300 bg-white px-4 py-3 text-sm text-stone-900 placeholder:text-stone-400 focus:outline-none focus:border-[#C85A32] transition-colors";

export const PublicReviewForm = ({ productId }) => {
  const { t } = useStore();
  const tr = t.reviewForm;
  const [form, setForm] = useState({ name: "", email: "", rating: 5, text: "" });
  const [open, setOpen] = useState(false);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/reviews`, { ...form, product_id: productId });
      setDone(true);
      toast.success(tr.thanks);
    } catch (err) {
      toast.error(err.response?.data?.detail || tr.error);
    } finally { setBusy(false); }
  };

  if (done) return <p className="text-sm text-[#4A624E]" data-testid="public-review-done">{tr.thanks}</p>;
  if (!open) {
    return (
      <button data-testid="public-review-open" onClick={() => setOpen(true)} className="rounded-full border border-stone-900 px-6 py-2.5 text-[11px] uppercase tracking-[0.15em] text-stone-900 hover:bg-stone-900 hover:text-white transition-colors">
        {tr.cta}
      </button>
    );
  }
  return (
    <form onSubmit={submit} className="rounded-2xl border border-stone-200 bg-white p-6 space-y-4" data-testid="public-review-form">
      <p className="text-xs text-stone-500 leading-relaxed">{tr.note}</p>
      <div className="flex gap-1" data-testid="public-review-rating">
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} type="button" data-testid={`public-review-star-${n}`} onClick={() => setForm({ ...form, rating: n })} aria-label={`${n}/5`}>
            <Star size={22} className={n <= form.rating ? "fill-[#C85A32] text-[#C85A32]" : "text-stone-300"} />
          </button>
        ))}
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <input data-testid="public-review-name" required minLength={2} className={inputCls} placeholder={tr.name} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <input data-testid="public-review-email" required type="email" className={inputCls} placeholder={tr.email} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
      </div>
      <textarea data-testid="public-review-text" required minLength={10} maxLength={800} rows={4} className={inputCls} placeholder={tr.placeholder} value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} />
      <div className="flex gap-2">
        <button data-testid="public-review-submit" type="submit" disabled={busy} className="rounded-full bg-stone-900 text-white px-6 py-3 text-[11px] uppercase tracking-[0.15em] hover:bg-[#C85A32] transition-colors disabled:opacity-60">{busy ? "..." : tr.send}</button>
        <button type="button" onClick={() => setOpen(false)} className="rounded-full border border-stone-300 px-5 py-3 text-[11px] uppercase tracking-[0.15em] text-stone-600">{t.checkout.close}</button>
      </div>
    </form>
  );
};
